import { render, staticRenderFns } from "./WordCloudLeftBar.vue?vue&type=template&id=5f89041a&scoped=true"
import script from "./WordCloudLeftBar.vue?vue&type=script&lang=js"
export * from "./WordCloudLeftBar.vue?vue&type=script&lang=js"
import style0 from "./WordCloudLeftBar.vue?vue&type=style&index=0&id=5f89041a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89041a",
  null
  
)

export default component.exports